import DuckEntity from './DuckEntity'

const entity = new DuckEntity('calendars');
const reducer = entity.reducer;
export {reducer as default, entity};
